export default class PeriodicPvrService {
	constructor(apiService) {
		this.apiService = apiService
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/periodicPvrs/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/PeriodicPvrService.js